<template>
    <div class="gradient-view pt-3 px-3 text-left">
        
      <div class="mb-3">
        <a class="btn btn-link text-primary px-0" @click="backToCollection">
          &lt; Back to {{collectionName}}</a> 
          <div class="float-right remove mr-2" @click="backToCollection">&times;</div>
      </div>
      <div class="bg-light rounded gradient-container mb-4 cursor-pointer" id="gradientContainer" @click="gradientContainerClicked" :style="gradientContent">
        <div class="hover-options">
          <!-- <div class="left" @click="backToCollection">
            <div class="icon">&#8592;</div>
            <div class="caption">Back</div>
          </div> -->
          <div class="right float-right mt-4 mr-4" @click.stop="enterFullScreen">
            <div class="icon">+</div>
            <div class="caption">Full Screen</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-5 col-lg-6">
          <ul class="nav nav-pills">
            <li class="nav-item mr-2">
              <a class="nav-link cursor-pointer" :class="{'active': showEditMenu }" @click="enableEditMenu()">Edit Gradient</a>
            </li>
            <li class="nav-item">
              <a class="nav-link cursor-pointer" :class="{'active': showCSSMenu }" @click="enableCSSMenu()">View CSS</a>
            </li>
          </ul>
        </div>
        <div class="col-7 col-lg-6">
            <button class="btn btn-outline-dark float-right" @click="copyCSS">Copy CSS</button>
            <image-download-button class="float-right mr-3 mr-lg-4" />
            <button class="btn btn-link text-dark float-right mr-3 mr-lg-4 mt-3 mt-md-0" @click="enterFullScreen">Full Screen</button>
        </div>
      </div>
      <div class="border rounded mt-4 mb-5 shadow-sm">
        <div class="edit-gradient-row row p-3" v-show="showEditMenu">
          <div class="match-boxes edit-colors col-8">
              <label class="edit-label mr-2">Edit Colors:</label> 
              <template v-for="(gc, index) in gradientColors">
                  <b-dropdown 
                      variant="link" 
                      size="sm"
                      dropup
                      no-caret
                      :key="index"
                      menu-class="p-2 color-dropdown"
                      @show="colorDropdownShown"
                      @hide="colorDropdownHidden"
                  >
                      <template v-slot:button-content>
                          <div class="match-box d-inline-block" :style="{'backgroundColor' : gc}"></div>
                      </template>
                      <div class="p-0" @click.prevent.stop>
                          <chrome-picker 
                              :value="gc"
                              @input="colorUpdated($event, gc)" 
                          />
                      </div>
                  </b-dropdown>
              </template>
          </div>
          <div class="col-4 col-sm-4 text-left rotate-input" v-if="canRotate">
              <div class="row">
                  <div class="col-12">
                      <label class="edit-label">Rotate:</label>
                      <ul class="rotate-list list list-inline ml-3 d-none d-lg-inline-block">
                        <li class="list-inline-item"><a href="#" @click.prevent="rotate(0)">0&deg;</a></li>
                        <li class="list-inline-item"><a href="#" @click.prevent="rotate(45)">45&deg;</a></li>
                        <li class="list-inline-item"><a href="#" @click.prevent="rotate(90)">90&deg;</a></li>
                        <li class="list-inline-item"><a href="#" @click.prevent="rotate(180)">180&deg;</a></li>
                        <li class="list-inline-item"><a href="#" @click.prevent="rotate(270)">270&deg;</a></li>
                      </ul>
                  </div>
                  <div class="col-lg-10 col-12 lh-50">
                      <input type="range" class="custom-range" min="0" max="360" :value="rotateDelta" @input="rotateUpdated($event)">
                  </div>
                  <div class="col-lg-2 col-12 delta-display pt-lg-0 pt-2">
                      <div class="">{{rotateDelta}}&deg;</div>
                  </div>
              </div>                        
          </div>
        </div>
        <div class="bg-gray-200" v-show="showCSSMenu">
          <div class="css-content p-3">
            <div class="text-left">
                <textarea class="form-control" rows="6" v-model="gradientContent"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import gradients from '@/util/gradients.js'
import collections from '@/util/collections.js'

import ImageDownloadButton from '@/components/ImageDownloadButton.vue'
import copyutils from '@/util/copyutils.js'
import { Chrome } from 'vue-color'
import debounce  from 'lodash.debounce'

const ESCAPE_KEY_CODE = 'Escape';
const COLOR_PRUNE_THRESHOLD = 25;

export default {
    props: {
        cid: {
            type: String,
            required: false
        },
        gid: {
            required: true,
            dropdownVisible: false
        }
    },
    components: {
        'chrome-picker': Chrome,
        ImageDownloadButton
    },
    metaInfo(){
      return {
        title: "View Gradient | Gradient Magic",
        meta: [
            { 
                vmid:'description', name: 'description', 
                content: `View and edit a CSS Gradient from the ${this.collectionName} collection.` 
            }
        ],
        link: [
            { vmid: 'canonical', rel: 'canonical', href: `https://www.gradientmagic.com/collection/${this.cid}/gradient/${this.gid}` }
        ]
      }
    },
    data(){
        return {
            // showLargePreview: false,
            modifiedGradientContent: '',
            rotateDelta: 0,
            showCSSMenu: false,
            showEditMenu: true,
            colorArray: []
        }
    },
    methods: {
        colorDropdownShown(){
          this.dropdownVisible = true;
        },
        colorDropdownHidden(){
          this.dropdownVisible = false;
        },
        enterFullScreen(){
          // let el = document.querySelector('.gradient-container');
          let gElement = document.getElementById("gradientContainer");

          if(gElement.requestFullscreen){
            gElement.requestFullscreen();
          }
          else if(gElement.mozRequestFullScreen){
            gElement.mozRequestFullScreen();
          }
          else if (gElement.webkitRequestFullScreen){
            gElement.webkitRequestFullScreen();
          }
        },
        // colorUpdated: debounce(function(newColorObject, oldColorString){
        //     let newColorString = this.rgbaToString(newColorObject.rgba)

        //     if(oldColorString == newColorString) return; // This was a fun bug to figure out

        //     let newGrad = this.rawGradientContent.replace(oldColorString,newColorString);

        //     // Need to do a "replace all", which can be tricky.  Wanted to avoid a regex solution
        //     while(newGrad.indexOf(oldColorString) != -1) newGrad = newGrad.replace(oldColorString,newColorString);
        //     this.modifiedGradientContent = newGrad;
        // }, 500),
        colorUpdated(newColorObject, oldColorString){
            let newColorString = this.rgbaToString(newColorObject.rgba)

            if(oldColorString == newColorString) return; // This was a fun bug to figure out

            console.log(`Updating color.  Old: ${oldColorString}, new: ${newColorString}`)
            
            let newGrad = this.rawGradientContent.replace(oldColorString,newColorString);

            // Need to do a "replace all", which can be tricky.  Wanted to avoid a regex solution
            while(newGrad.indexOf(oldColorString) != -1) newGrad = newGrad.replace(oldColorString,newColorString);

            // Update colors
            // this.colorArray = this.colorArray.map((obj) => {
            //   if(obj == oldColorString) return newColorString
            //   return obj
            // })

            this.modifiedGradientContent = newGrad;
        },
        rgbaToString(colorObject){
            if(colorObject.a == 1) return `rgb(${colorObject.r},${colorObject.g},${colorObject.b})`
            else return `rgba(${colorObject.r},${colorObject.g},${colorObject.b}, ${colorObject.a})`
        },
        rotateUpdated(e){
            let newDelta = parseInt(e.target.value);
            this.rotate(newDelta);
        },
        rotate(newDegrees){
            if(newDegrees == this.rotateDelta) return
            let difference = newDegrees - this.rotateDelta;

            let rotateRegex = /\(\d+deg/g
            let newGrad = this.rawGradientContent;

            function changeDegrees(match, offset, string){
                let degValue = parseInt(match.substring(1, match.length-3))
                let newDegString = `(${degValue + difference}deg`
                return newDegString;
            }

            newGrad = newGrad.replace(rotateRegex, changeDegrees);

            // Change the displayed gradient
            this.modifiedGradientContent = newGrad

            // Set old delta to the new one
            this.rotateDelta = newDegrees;
        },
        // collectionName(cid){
        //     let col = collections.find((obj) => {
        //         return obj.id == cid;
        //     })
        //     return col.title;
        // },
        escapeKeyListener(e){
            if(e.key == ESCAPE_KEY_CODE){
                this.backToCollection();
            }
        },
        copyCSS(e){
            copyutils.copyGradientToClipboard(this.gradientContent, this.gradient.date);
            e.stopPropagation();
        },
        // handleClick(e){
        //     if(e.target.id != 'largePreview') return
        //     if(this.dropdownVisible) return

        //     this.backToCollection();
        // },
        currentlyFullScreen(){
          if(document.fullscreenElement) return true;
          if(document.webkitFullscreenElement) return true;
          if(document.msFullscreenElement) return true;
          return false;
        },
        exitFullScreen(){
          if(document.exitFullscreen) document.exitFullscreen();
          else if(document.webkitExitFullscreen) document.webkitExitFullscreen();
          else if(document.msExitFullscreen) document.msExitFullscreen();
        },
        gradientContainerClicked(){
          if(this.currentlyFullScreen()){
            this.exitFullScreen();
          }
          else {
            // Sometimes it's just to de-focus the dropdown
            if(!this.dropdownVisible) this.backToCollection();
          }
        },
        backToCollection(){
            // Go back if possible, as that is a better UX (keeps them scrolled)
            if(this.previousRoute && this.previousRoute.name) this.$router.go(-1);
            else this.$router.push({path: `/collection/${this.cid}`})
        },
        downloadImage(){

        },
        enableEditMenu(){
          this.showEditMenu = true;
          this.showCSSMenu = false;
        },
        enableCSSMenu(){
          this.showCSSMenu = true;
          this.showEditMenu = false;
        }
    },
    computed: {
        gradient(){
            return gradients.find((obj) => {
                return obj.date == this.gid;
            })
        },
        rawGradientContent(){
            if(this.modifiedGradientContent.length > 0) return this.modifiedGradientContent
            else return this.gradient.content;
        },
        gradientContent: {
            get: function(){
                let content = this.rawGradientContent;

                if(content.indexOf('background-image') != -1){
                    return content; // Already has full CSS styles
                }
                else {
                    return `background-image: ${content};`
                }
            },
            set: function(newValue){
                this.modifiedGradientContent = newValue;
            }
        },
        gradientName(){
            return this.gradient.name;
        },
        gradientColors(){
            let colorRegex = /rgb[a]*\([\d\,\.\s]+\)|hsl[a]*\([\d\,\.\%\s]+\)|\#[\dabcdef]+/g // eslint-disable-line
            let matches = this.rawGradientContent.match(colorRegex)
            let uniqueMatches = new Set(matches);
            let uniqueColors = Array.from(uniqueMatches);

            if(uniqueColors.length > COLOR_PRUNE_THRESHOLD){
                uniqueColors.splice(0, (uniqueColors.length - COLOR_PRUNE_THRESHOLD));
            }

            return uniqueColors
        },
        canRotate(){
            let rotateRegex = /\(\d+deg/g
            let matches = this.rawGradientContent.match(rotateRegex)
            if (matches) return true
            return false
        },
        collectionName(){
            let cid = this.cid

            let col = collections.find((obj) => {
                return obj.id == cid;
            })
            return col.title;
        },
    },
    beforeRouteEnter(to, from, next){
        next(vm => {
            vm.previousRoute = from;
        })
    },
    created(){
        document.addEventListener('keydown', this.escapeKeyListener);
    },
    beforeDestroy(){
        document.removeEventListener('keydown', this.escapeKeyListener);
    }
}
</script>

<style lang="scss">
.gradient-view {
    .bg-gray-200 {
      background-color: #ececec; 
    }
    .lh-50 {
      line-height: .5;
    }
    .remove {
      color: $gray-400;
      font-size: 270%;
      line-height: 2.8rem;
      font-weight: bold;
      cursor: pointer;
      transition: .6s;
      &:hover {
        color: $secondary;
      }
    }

    .hover-options {

      .right {
        background-color: rgba(255,255,255,.4);
        border: 1px solid rgba(0,0,0,.05);
        border-radius: 6px;
        width: 14%;
        padding: 0 1.5rem 1rem 1.5rem;
        transition: .5s all;
        &:hover {
          background-color: rgba(255,255,255,.8);
        }
      }

      .icon {
        font-size: 3.5rem;
        text-align: center;
        line-height: 4rem;
      }
      .caption {
        font-size: 1rem;
        text-transform: uppercase;
        text-align: center;
        font-weight: bold;
      }
      opacity: 0;
      transition: .8s all;
    }

    .gradient-container {
      &:hover {
        .hover-options {
          opacity: 1;
        }
      }
      min-height: 600px;  
    }

    @media all and (display-mode: fullscreen){
      .gradient-container:hover .hover-options {
        opacity: 0;
      }
    }

    .nav-pills .nav-link.active {
      // background-color: $light;
      background-color: #ececec;
      color: $dark;
    }

    .bottom-pane {
        border: 1px solid #dde3e6;
        // border-top: none;
        border-radius: 4px 4px 4px 4px;
    }
    .edit-gradient-row {

        .rotate-input {
            line-height: 2.4rem;
            .custom-range {
                vertical-align: middle;
            }
        }

        .delta-display {
          line-height: 1.6;
          font-size: .85rem;
        }

        .rotate-list {
          display: inline-block;
          font-size: .85rem;
          li {
            margin-right: .75rem;
          }
          margin-bottom: 0;
        }

        .edit-label {
            text-transform: uppercase;
            font-size: .85rem;
            margin-bottom: 0;
        }
        .match-box {
            height: 20px;
            min-width: 30px;
            border-radius: 4px;
            border: 1px solid #aaa;
            cursor: pointer;
        }
        // Not sure why this needs to be done manually
        .dropdown-toggle-no-caret::after {
            border: none !important;
        }
    }

}

*:fullscreen, *:-webkit-full-screen, *:-moz-full-screen {
    // https://stackoverflow.com/questions/16163089/background-element-goes-black-when-entering-fullscreen-with-html5
    // (see comments to accepted answer)
    // Need to set dimensions, or its all black.
    width: 100%;
    height: 100%;
}

</style>